import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest
} from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {

    const user = JSON.parse(localStorage.getItem('user') || '{}');
    const token = user?.token;
    console.log("token",token)
    // Clone request and add header
    if (token) {
      const clonedReq = req.clone({
        setHeaders: {
          Authorization: `${token}`,
          'Content-Type': 'application/json'
        }
      });

      return next.handle(clonedReq);
    }

    return next.handle(req);
  }
}